/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M440.162 14H70.91C31.815 14 0 45.815 0 84.938v216.943c0 39.123 31.815 70.938 70.91 70.938h47.177v82.747c0 18.143 11.38 34.337 28.462 40.47a43.163 43.163 0 0014.503 2.523c12.61 0 24.85-5.56 33.19-15.65l90.773-110.09h155.147c39.123 0 70.938-31.815 70.938-70.938V84.938C511.1 45.815 479.285 14 440.162 14m0 42.993c15.449 0 27.945 12.525 27.945 27.945v216.943c0 15.449-12.496 27.945-27.945 27.945h-175.44L161.08 455.566v-125.74H70.91c-15.42 0-27.917-12.496-27.917-27.945V84.938c0-15.42 12.497-27.945 27.917-27.945h369.252"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconComment = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconComment.defaultProps = {
  theme,
};
IconComment.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconComment.displayName = 'IconComment';
export { IconComment };
